import { DefaultValue } from "recoil";

export const localStoragePersistenceEffect =
  <T>(key: string) =>
  (params: {
    setSelf: (
      param:
        | T
        | DefaultValue
        | Promise<T | DefaultValue>
        | ((param: T | DefaultValue) => T | DefaultValue),
    ) => void;
    onSet: (
      param: (
        newValue: T,
        oldValue: T | DefaultValue,
        isReset: boolean,
      ) => void,
    ) => void;
  }) => {
    const { setSelf, onSet } = params;
    const nullReviver = (reviverKey: string, value: any) => {
      if (!value) return null;
      return value;
    };
    const nullReplacer = (replacerKey: string, value: any) => {
      if (!value) {
        return null;
      }
      return value;
    };
    const savedValue = localStorage.getItem(key);
    if (savedValue) {
      try {
        const parsed = JSON.parse(savedValue, nullReviver);
        setSelf(parsed);
      } catch (error) {
        console.error(`Failed to parse localStorage value for key "${key}":`, error);
        localStorage.removeItem(key);
      }
    }

    onSet((newValue, _: DefaultValue | T, isReset: boolean) => {
      if (isReset) {
        localStorage.removeItem(key);
      } else {
        try {
          localStorage.setItem(key, JSON.stringify(newValue, nullReplacer));
        } catch (error) {
          console.error(`Failed to save value to localStorage for key "${key}":`, error);
        }
      }
    });
  };
